
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, Renderer2, Injector } from '@angular/core';
import { ComponentFactoryResolver, ChangeDetectorRef, ViewChild, ViewContainerRef } from '@angular/core';

import { DynamicBaseComponent } from '../dynamic-base.component';

import * as moment_api from 'moment';
const moment = moment_api;

@Component({
    selector: 'modal-overlay',
    template: `<div [class]="'modal ' + model.name + ( top ? ' top' : '' )" widget [@show] (window:click)="close($event)">
    <div class="container">
        <div #body class="body" [class.top]="top" (click)="tap()" [@show]>
            <ng-container #content></ng-container>
            <ng-container *ngTemplateOutlet="model.template"></ng-container>
        </div>
    </div>
</div>`,
    styles: [`.modal{position:absolute;top:0;left:0;right:0;bottom:0;overflow:auto;background-color:rgba(0,0,0,0);z-index:2000;pointer-events:auto;-webkit-transition:background-color .2s;transition:background-color .2s}.modal.top{background-color:rgba(0,0,0,.54)}.container{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.body{max-height:90vh;max-width:90vw;border-radius:.2em}`],
    animations: [
        trigger('show', [
            transition(':enter', [ style({ opacity: 0 }), animate(300, style({ opacity: 1 })) ]),
            transition(':leave', [ style({ opacity: 1 }), animate(300, style({ opacity: 0 })) ]),
        ]),
        trigger('enter', [
            transition(':enter', [
                animate(200, keyframes([
                    style({ transform: 'translateX(-200%)', offset: 0 }),
                    style({ transform: 'translateX(10%)', offset: .9 }),
                    style({ transform: 'translateX(0%)', offset: 1})
                ]))
            ]),
            transition(':leave', [
                animate(200, keyframes([
                    style({ transform: 'translateX(0%)', offset: 0 }),
                    style({ transform: 'translateX(-10%)', offset: .1 }),
                    style({ transform: 'translateX(200%)', offset: 1})
                ]))
            ]),
        ]),
    ],
})
export class ModalComponent extends DynamicBaseComponent {
    public top: boolean;

    protected type = 'Modal';

    constructor(private injector: Injector) {
        super();
        this._cfr = this.injector.get(ComponentFactoryResolver);
        this._cdr = this.injector.get(ChangeDetectorRef);
        this.renderer = this.injector.get(Renderer2);
    }

    public resize() {
        setTimeout(() => {
            const el = this.model.el;
            if (el && el.nativeElement) {
                this.cntr_box = el.nativeElement.getBoundingClientRect();
            }
        }, 100);
    }

    public updateState(state: string) {
        setTimeout(() => this.top = state === this.stack_id);
    }

    public close(e?: Event) {
        if (DynamicBaseComponent.instance_stack[this.type]) {
            const length = DynamicBaseComponent.instance_stack[this.type].length;
            if (DynamicBaseComponent.instance_stack[this.type][length - 1] === this.stack_id && !DynamicBaseComponent.action) {
                super.close(e);
            }
        } else {
            super.close(e);
        }
    }

    protected update(data: any) {
        this.resize();
        super.update(data);
    }
}
